<div class="modal inmodal fade alert-modal"
     id="alert-modal-id"
     tabindex="-1"
     role="dialog"
     aria-hidden="true"
     #thisModal>
  <div class="modal-dialog alert-modal__alert-dialog"
       role="document">
    <div class="modal-content alert-modal__alert-dialog__alert-content">
      <div class="modal-header alert-modal__alert-dialog__alert-content__alert-header">
        <h4 id="alertModalLabel">
          {{'components.errorMessageComponent.title' | translate}}
        </h4>
      </div>
      <div class="modal-body font-weight-bold alert-modal__alert-dialog__alert-content__alert-body">
        <span class="fa fa-exclamation-circle" aria-hidden="true"></span>
        <div class="modal-body font-weight-bold alert-modal__alert-dialog__alert-content__alert-body-messages">
          <label [innerHTML]="errorMessage | safeHtml"></label>
        </div>
      </div>
      <div class="modal-footer alert-modal__alert-dialog__alert-content__alert-footer">
        <button type="button"
                class="btn btn-default"
                (click)="onClose()"
                data-dismiss="modal">
          <span class="fa fa-check"></span>
          <span>{{'components.errorMessageComponent.ok' | translate}}</span>
        </button>
      </div>
    </div>
  </div>
</div>
